import { CAPABILITY_ROLES, rolesRefusedBy } from '@prerender/prerender-shared/FE';

// The roles each write control must refuse, derived from the one role matrix in
// @prerender/prerender-shared that also gives dashboard-api its `ensureRoleIn` allow-lists
// (COR-839). Derived rather than written out here: the control and the route it calls then come
// from one declaration, so the UI can no longer hide an action the route still permits — the
// Broken Function Level Authorization defect of COR-837.
//
// `disabledFor` takes the roles to refuse, which is the complement of the permitted list.
// Computing that complement also means a role added to `UserRole` is refused by the control on the
// same edit that leaves it out of the server allow-list.
export const CONTENT_WRITE_REFUSED_ROLES = rolesRefusedBy('contentWrite');
export const BILLING_WRITE_REFUSED_ROLES = rolesRefusedBy('billingWrite');
export const TOKEN_WRITE_REFUSED_ROLES = rolesRefusedBy('tokenWrite');

// The permitted list for the same capability, for a control that takes an allow-list rather than a
// `disabledFor` deny-list — `useIsRoleIn` in components/ButtonWithRole. The same matrix entry as
// CONTENT_WRITE_REFUSED_ROLES, so the two directions cannot state different things.
export const CONTENT_WRITE_ROLES = CAPABILITY_ROLES.contentWrite;
